import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Util} from "../../app/util";
import {CONFIG} from "../../app/config";

@Component({
    selector: 'time-picker',
    templateUrl: 'time-picker.html'
})

export class TimePicker {

    public config: any;

    public hora: string;
    public minu: string;

    @Input() private step: number = 30;
    @Input() private time: string;
    @Output() private timeChange = new EventEmitter();

    constructor(public util: Util) {

        this.config = CONFIG;

    }

    ngOnInit() {

        if (!this.time) this.time = '00:00';

        this.hora = this.time.split(':')[0];
        this.minu = this.time.split(':')[1];

    }

    upDown(elem: 'hora' | 'minu', dire: 'up' | 'down') {

        let hora: string | number = parseInt(this.hora, 10),
            minu: string | number = parseInt(this.minu, 10);

        if (elem == 'hora') {

            hora += {'up': 1, 'down': -1}[dire];

            hora = hora > 23 ? 0 : hora;
            hora = hora < 0 ? 23 : hora;

            hora = hora < 10 ? '0' + hora.toString() : hora.toString();

            this.hora = hora;
        }
        else {

            minu += {'up': this.step-1+1, 'down': this.step * -1}[dire];

            minu = minu > 59 ? 0 : minu;
            minu = minu < 0 ? (60-this.step) : minu;

            minu = minu < 10 ? '0' + minu.toString() : minu.toString();

            this.minu = minu;
        }

        this.timeChange.emit(this.hora + ':' + this.minu);

    }


}



// WEBPACK FOOTER //
// ./src/components/time-picker/time-picker.ts